const SHARE_ID_PATTERN = /^[a-z0-9][a-z0-9-]{3,120}$/;
const SESSION_ID_PATTERN = /^[a-zA-Z0-9_-]{6,128}$/;

export type ShareSessionRoute =
  | { kind: 'none' }
  | { kind: 'share'; shareId: string }
  | { kind: 'session'; sessionId: string }
  | {
      kind: 'invalid';
      param: 'share' | 'session';
      reason: 'missing' | 'malformed';
    };

export const resolveShareSessionRoute = (search: string): ShareSessionRoute => {
  const params = new URLSearchParams(search);

  if (params.has('share')) {
    const shareValue = params.get('share');
    const shareId = shareValue?.trim() || '';

    if (!shareId) {
      return { kind: 'invalid', param: 'share', reason: 'missing' };
    }

    if (!SHARE_ID_PATTERN.test(shareId)) {
      return { kind: 'invalid', param: 'share', reason: 'malformed' };
    }

    return { kind: 'share', shareId };
  }

  if (params.has('session')) {
    const sessionValue = params.get('session');
    const sessionId = sessionValue?.trim() || '';

    if (!sessionId) {
      return { kind: 'invalid', param: 'session', reason: 'missing' };
    }

    if (!SESSION_ID_PATTERN.test(sessionId)) {
      return { kind: 'invalid', param: 'session', reason: 'malformed' };
    }

    return { kind: 'session', sessionId };
  }

  return { kind: 'none' };
};

export const stripShareSessionParams = (urlLike: string): string => {
  const url = new URL(urlLike, window.location.origin);
  url.searchParams.delete('share');
  url.searchParams.delete('session');

  const search = url.searchParams.toString();
  return `${url.pathname}${search ? `?${search}` : ''}${url.hash}`;
};

export const getInvalidShareSessionMessage = (
  invalid: Extract<ShareSessionRoute, { kind: 'invalid' }>
): string => {
  if (invalid.param === 'share') {
    return 'Invalid share link. Please ask the owner for a new link.';
  }

  return 'Invalid legacy session link. Please verify the URL or request a new link.';
};

